import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Card, CardHeader, Col, Input, Label, Media, Table } from 'reactstrap';
import { Breadcrumbs, H5, ToolTip } from '../../AbstractElements';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Filter, PlusCircle, X } from 'react-feather';
import { FormLabel } from 'react-bootstrap';
import MyPagination from '../pagination';
import errorImage from "../../assets/images/blank_profile.png"
import { getSubAdminListAPI, listAPI, updateAPI } from './service/manage-staff-service';
import { useLoader } from '../../_helper/LoaderContext';
import PrivilegeContext from '../../_helper/PrivilegeContext';
import { decryptResponseData } from '../../Services/decryptApiResponse';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLicense } from '../../_helper/license/LicenseContext';
import S3ImageLoader from '../../S3ImageLoader';

const StaffList = () => {
    const { privileges } = useContext(PrivilegeContext);
    const [editTooltipOpen, setEditTooltipOpen] = useState(false);
    const [filterTooltipOpen, setFilterTooltipOpen] = useState(false);
    const [clearTooltipOpen, setClearTooltipOpen] = useState(false);
    const [viewTooltipOpen, setViewTooltipOpen] = useState(false);
    const toggleEditTooltip = () => setEditTooltipOpen(!editTooltipOpen);
    const toggleFilterTooltip = () => setFilterTooltipOpen(!filterTooltipOpen);
    const toggleClearTooltip = () => setClearTooltipOpen(!clearTooltipOpen);
    const toggleViewTooltip = () => setViewTooltipOpen(!viewTooltipOpen);

    const [statusTooltips, setStatusTooltips] = useState({});
    const toggleStatusTooltip = (_id) => {
        setStatusTooltips((prev) => ({
            ...prev,
            [_id]: !prev[_id],
        }));
    };

    const history = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const [totalItems, setTotalItems] = useState(0);
    const [totalUserCount, setTotalUserCount] = useState(0);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [listData, setList] = useState([]);
    const { setLoading } = useLoader();
    const [skeletonLoading, setSkeletonLoading] = useState(true);
    const { t } = useTranslation();
    const [isClearing, setIsClearing] = useState(false);
    const imageBaseURL = process.env.REACT_APP_IMAGE;
    const menu_key = "manage_admin_users";
    const [listView, setListView] = useState(false);
    const [addView, setAddView] = useState(false);
    const [updateView, setUpdateView] = useState(false);
    const [viewView, setViewView] = useState(false);
    const [acitve_inactiveView, setActiveInactiveView] = useState(false);
    const { decodeTokenOnly } = useLicense();

    const [allowedUsers, setAllowedUsers] = useState(0);
    const [licenseUsers, setLicenseUsers] = useState([]);

    useEffect(() => {
        decodeTokenOnly().then(decoded => {
            if (decoded) {
                setAllowedUsers(decoded?.limitations?.users_allowed || 0);
                setLicenseUsers(decoded?.users || []);
            }
        });
    }, [decodeTokenOnly]);

    useEffect(() => {
        // Fetch List data when component mounts
        getList();
    }, [page, size]);

    const getList = async () => {
        const body = {
            pageNo: page,
            pageSize: size,
            search: searchValue.trim(),
            // role: ''
        }
        try {
            setLoading(true);
            setSkeletonLoading(true);
            const response = await getSubAdminListAPI(body)
            // const dec_data = decryptResponseData(response)
            if (response.data.status === 'success') {
                setList(response.data.data.subAdminUserList);
                const totalCount = response.data.data.totalSubAdmin;
                setTotalUserCount(totalCount)
                const totalPagesItems = Math.ceil(totalCount / size);
                setTotalItems(totalPagesItems);
                getPermission();
                setLoading(false);
                setSkeletonLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setSkeletonLoading(false);
            console.error('Error fetching data:', error);
        }
    };

    const getPermission1 = () => {
        if (privileges) {
            privileges.permissions.forEach(element => {
                if (element.menu_key === menu_key) {
                    if (element.actions && element.actions.length > 0) {
                        element.actions.forEach(action => {
                            if (action.key === 'list') {
                                if (action.allowed) {
                                    setListView(true);
                                }
                            }
                            if (action.key === 'add') {
                                if (action.allowed) {
                                    setAddView(true);
                                }
                            }
                            if (action.key === 'update') {
                                if (action.allowed) {
                                    setUpdateView(true);
                                }
                            }
                            if (action.key === 'view') {
                                if (action.allowed) {
                                    setViewView(true);
                                }
                            }
                            if (action.key === 'active_inactive') {
                                if (action.allowed) {
                                    setActiveInactiveView(true);
                                }
                            }
                        })
                    }
                }
            });
        }
    }

    const getPermission = () => {
        if (privileges && privileges.permissions) {
            const permissionMap = {
                list: setListView,
                add: setAddView,
                update: setUpdateView,
                view: setViewView,
                active_inactive: setActiveInactiveView,
            };

            privileges.permissions.forEach((element) => {
                if (element.menu_key === menu_key && element.actions) {
                    element.actions.forEach((action) => {
                        if (action.key in permissionMap && action.allowed) {
                            permissionMap[action.key](true);
                        }
                    });
                }
            });
        } else {
            setListView(true);
            setAddView(true);
            setUpdateView(true);
            setViewView(true);
            setActiveInactiveView(true);
        }
    };

    // const formatDate = (createdAt) => {
    //     const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    //     const date = new Date(createdAt);
    //     const day = date.getDate();
    //     const monthIndex = date.getMonth();
    //     const year = date.getFullYear();

    //     // Ensure leading zeros for single-digit days
    //     const formattedDay = day < 10 ? '0' + day : day;
    //     return `${formattedDay} ${months[monthIndex]} ${year}`;
    // };

    // Handle search button click
    const handleSearchButtonClick = () => {
        if (searchValue.trim() !== "") {
            setPage(1); // Reset page to 1
            getList(); // Trigger the API call for search
        }
    };

    const handleClear = () => {
        setIsClearing(true);
        setSearchValue(''); // Clear the search value
    };

    useEffect(() => {
        if (isClearing) {
            getList(); // Trigger the API call when clearing search
            setIsClearing(false); // Reset clearing state
        }
    }, [isClearing]);

    // Handle search field input change (but don't trigger API call)
    const handleSearchChange = (event) => {
        setSearchValue(event.target.value); // Just update the state
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (e) => {
        const newSize = parseFloat(e.target.value); // Parse the value without triggering a state update
        setSize(newSize); // Update the state after parsing the value
        setPage(1); // Reset currentPage to 1 when changing page size
    }

    const addForm = () => {
        history(`${process.env.PUBLIC_URL}/manage-staffs/add`);
    };

    // Event handler for opening edit component
    const handleEditClick = (getID) => {
        // console.log(getID);
        history(`${process.env.PUBLIC_URL}/manage-staffs/edit/${getID}`);
    };

    // Event handler for opening view component
    const handleViewClick = (getID) => {
        // console.log(getID);
        history(`${process.env.PUBLIC_URL}/manage-staffs/view/${getID}`);
    };

    const statusChange = async (_id, event) => {
        const newStatus = event.target.checked; // true or false

        Swal.fire({
            icon: 'warning',
            title: t("Are you sure"),
            text: newStatus ? t("you wish to Activate this user?") : t("you wish to Inactive this user?"),
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn-primary',
                cancelButton: 'btn-danger',
            },
            confirmButtonText: newStatus ? t("Yes, Activate") : t("Yes, Inactive"),
            cancelButtonText: t("Cancel")
        }).then(async (result) => {
            if (result.value) {

                const requestBody = {
                    _id,
                    status: newStatus
                };

                try {
                    setLoading(true);
                    const file = [];
                    const response = await updateAPI(requestBody, file);
                    const dec_data = decryptResponseData(response);

                    if (dec_data.status === 'success') {
                        getList();
                        toast.success(dec_data.message);
                    }
                } catch (error) {
                    console.error("Error updating status:", error);
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const nonAdminUserCount = licenseUsers.filter(
        user => user.type !== "admin"
    ).length;

    const canAddStaff =
        addView && totalUserCount < allowedUsers;

    return (
        <Fragment>
            <Breadcrumbs mainTitle={t('List Of Staffs')} parent={t('Dashboard')} title={t('List Of Staffs')} />
            <Col sm="12">
                <Card>
                    <CardHeader className="d-flex justify-content-between align-items-center">
                        <H5>{t('List')}</H5>
                        {canAddStaff && (
                            <button
                                className="btn btn-primary d-flex align-items-center"
                                style={{ color: 'white', height: "40px" }}
                                to=""
                                onClick={addForm}>
                                <PlusCircle className="me-2" /> {t("Add A Staff")}
                            </button>
                        )}
                    </CardHeader>
                    {listView && (
                        <div className="row" style={{ alignItems: "center", padding: "12px 24px" }}>
                            <Col sm="8" lg="8" xl="10" md="8">
                                <Input
                                    name="SearchData"
                                    id="SearchData"
                                    type="text"
                                    placeholder={t("Search By Staff Name, Email Or Phone Number")}
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                    style={{
                                        // backgroundColor: '#ffffff',
                                        // color: '#212529',
                                        // border: '1px solid #ffffff',
                                        lineHeight: 1.8, fontSize: "1rem !important"
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearchButtonClick();
                                        }
                                    }}
                                />
                            </Col>
                            <Col className="col-xl-2 col-lg-4 col-md-4 col-sm-4 d-flex justify-content-start align-items-center" style={{ gap: '18px' }}>
                                <button id='FilterToolTip' className='btn btn-primary' style={{ height: "40px" }} onClick={handleSearchButtonClick}>
                                    <Filter />
                                </button>
                                <ToolTip
                                    attrToolTip={{
                                        placement: 'top',
                                        isOpen: filterTooltipOpen,
                                        target: 'FilterToolTip',
                                        toggle: toggleFilterTooltip,
                                    }} >
                                    <strong>{t("Filter")}</strong>
                                </ToolTip>
                                <button id='ClearToolTip' className='btn btn-secondary' style={{ height: "40px" }} onClick={handleClear}>
                                    <X />
                                </button>
                                <ToolTip
                                    attrToolTip={{
                                        placement: 'top',
                                        isOpen: clearTooltipOpen,
                                        target: 'ClearToolTip',
                                        toggle: toggleClearTooltip,
                                    }} >
                                    <strong>{t("Clear")}</strong>
                                </ToolTip>
                            </Col>
                        </div>
                    )}
                    {listView && (
                        <div className="card-block">
                            <div className='row' style={{ padding: "12px 24px" }}>
                                <Col sm="12" lg="12" xl="12">
                                    <div className="table-responsive rounded">
                                        <Table className='table-center table-bordered mb-0 table-hover'>
                                            <thead>
                                                <tr>
                                                    <th className="border-bottom p-3" width="2%">#</th>
                                                    <th className="border-bottom p-3" width="30%">{t("Staff Name")}</th>
                                                    <th className="border-bottom p-3" width="15%">{t("Email")}</th>
                                                    <th className="border-bottom p-3" width="14%">{t("Phone Number")}</th>
                                                    {/* <th className="border-bottom p-3" width="7%">{t("Profile")}</th> */}
                                                    {/* <th className="border-bottom p-3" width="12%">{t("Designation")}</th> */}
                                                    {/* <th className="border-bottom p-3" width="12%">{t("Role")}</th> */}
                                                    {/* <th className="border-bottom p-3" width="8%">{t("Wallet Balance")}</th> */}
                                                    {/* <th className="border-bottom p-3" width="8%">{t("Gender")}</th> */}
                                                    {/* <th className="border-bottom p-3" width="7%">{t("Status")}</th> */}
                                                    <th className="border-bottom p-3 text-center" width="12%">{t("Action")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {skeletonLoading ? (
                                                    // Skeleton rows
                                                    [...Array(5)].map((_, index) => (
                                                        <tr key={index}>
                                                            <td><Skeleton height={20} /></td>
                                                            <td><Skeleton height={20} width="80%" /></td>
                                                            <td><Skeleton height={20} width="60%" /></td>
                                                            <td><Skeleton height={20} width="60%" /></td>
                                                            <td className='text-center' style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                                                                <Skeleton circle height={35} width={35} />
                                                                <Skeleton circle height={35} width={35} />
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : listData.length > 0 ? (
                                                    listData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{(page - 1) * size + index + 1}</td>
                                                            <td>
                                                                {item?.contact_person.profile_picture ? (
                                                                    // <img src={imageBaseURL + item?.contact_person?.profile_picture}
                                                                    //     className="display-image" alt=""
                                                                    //     onError={(e) => {
                                                                    //         e.target.src = errorImage;
                                                                    //     }} />
                                                                    <S3ImageLoader
                                                                        className="m-0 display-image"
                                                                        fileName={item?.contact_person?.profile_picture}
                                                                        alt="profile"
                                                                        fallbackSrc={errorImage}
                                                                    />
                                                                ) : (
                                                                    <img src={errorImage} className="display-image" alt="Error" />
                                                                )}&nbsp;
                                                                {item?.contact_person.full_name || item?.contact_person.first_name + " " + item?.contact_person.last_name}&nbsp;
                                                                {item?.isAdmin && (
                                                                    <span className='badge bg-success rounded-5'>
                                                                        {t("Admin")}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td>{item?.email}</td>
                                                            <td>{item?.contact_person.phone_code} {item?.contact_person.mobile}</td>
                                                            {/* <td>{item?.privileges_profile_name}</td> */}
                                                            {/* <td>
                                                            {item?.designation}
                                                        </td> */}
                                                            {/* <td style={{ textTransform: "capitalize" }}>
                                                                {item?.role}
                                                            </td> */}
                                                            {/* <td className="text-center">
                                                                {Object.entries(item.wallets || {}).map(([currency, amount]) => (
                                                                    <span key={currency} className="d-block">
                                                                        {currency}: {(amount || 0).toFixed(2)}
                                                                    </span>
                                                                ))}
                                                            </td> */}

                                                            {/* <td style={{ textTransform: "capitalize" }}>{item?.gender}</td> */}
                                                            {/* <td>
                                                                {acitve_inactiveView && (
                                                                    <>
                                                                        <Media body className="text-center icon-state">
                                                                            <Label className='switch' id={`status-${item?._id}`} htmlFor={`flexSwitchCheck-${item._id}`}>
                                                                                <Input
                                                                                    type='checkbox'
                                                                                    id={`flexSwitchCheck-${item._id}`}
                                                                                    checked={item.status}
                                                                                    onChange={(e) => statusChange(item._id, e)}
                                                                                />
                                                                                <span className='switch-state'></span>
                                                                            </Label>
                                                                        </Media>
                                                                        <ToolTip
                                                                            attrToolTip={{
                                                                                placement: 'top',
                                                                                isOpen: statusTooltips[item?._id] || false,
                                                                                target: `status-${item?._id}`,
                                                                                toggle: () => toggleStatusTooltip(item?._id),
                                                                            }} >
                                                                            <strong>{t("Change Status")}</strong>
                                                                        </ToolTip>
                                                                    </>
                                                                )}
                                                            </td> */}
                                                            <td className='text-center'>
                                                                {updateView && (
                                                                    <button className='success-action-button me-1' id="EditToolTip" onClick={() => handleEditClick(item?._id)}>
                                                                        <i className="fa fa-pencil-square" style={{ fontSize: "18px" }}></i>
                                                                        <ToolTip
                                                                            attrToolTip={{
                                                                                placement: 'top',
                                                                                isOpen: editTooltipOpen,
                                                                                target: 'EditToolTip',
                                                                                toggle: toggleEditTooltip,
                                                                            }} >
                                                                            <strong>{t("Edit")}</strong>
                                                                        </ToolTip>
                                                                    </button>
                                                                )}
                                                                {viewView && (
                                                                    <button className='success-action-button' id="ViewToolTip" onClick={() => handleViewClick(item?._id)}>
                                                                        <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                                        <ToolTip
                                                                            attrToolTip={{
                                                                                placement: 'top',
                                                                                isOpen: viewTooltipOpen,
                                                                                target: 'ViewToolTip',
                                                                                toggle: toggleViewTooltip,
                                                                            }} >
                                                                            <strong>{t("View")}</strong>
                                                                        </ToolTip>
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr className="text-center">
                                                        <td colSpan="9">{t("No records available at this time.")}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                                <Col sm="12" lg="12" xl="12" className="mt-4">
                                    <div className="d-md-flex align-items-center text-center justify-content-between">
                                        <div className="show-entries pt-3">
                                            <FormLabel>{t("Show")}&nbsp;</FormLabel>
                                            <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={size} onChange={handlePageSizeChange} className="form-control">
                                                <option value={5}>5</option>
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={30}>30</option>
                                                <option value={50}>50</option>
                                            </select>&nbsp;
                                            <FormLabel>{t("entries")}</FormLabel>
                                        </div>
                                        <MyPagination totalPages={totalItems} currentPage={page} onPageChange={handlePageChange} />
                                    </div>
                                </Col>
                            </div>
                        </div>
                    )}
                </Card>
            </Col>
        </Fragment>
    )
};

export default StaffList;
